import { render, staticRenderFns } from "./authenticatie.vue?vue&type=template&id=7789f8e3&scoped=true"
import script from "./authenticatie.vue?vue&type=script&lang=js"
export * from "./authenticatie.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7789f8e3",
  null
  
)

export default component.exports